import { render, staticRenderFns } from "./cg-logo.vue?vue&type=template&id=f153c0ee&scoped=true"
import script from "./cg-logo.vue?vue&type=script&lang=js"
export * from "./cg-logo.vue?vue&type=script&lang=js"
import style0 from "./cg-logo.vue?vue&type=style&index=0&id=f153c0ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f153c0ee",
  null
  
)

export default component.exports